import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "NewSupportTicket" })
export default class NewSupportTicket extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = { vehicleType: null, topic: null };
    public validationErrors: any[] = [];
    public topics: any[] = [];
    public isForm: boolean = false;
    public isProductCodeReport: boolean = false;
    public faqs: any = {};
    public registrationFileName: string = null;

    public isHoliday: boolean = false;
    public redirectUrl: string = null;

    @Prop() readonly region: string;
    @Prop() readonly defaultTopic: string;

    @Watch("formData.topic") onTopicChanged(value: any) {
        this.validationErrors = [];

        if (value) {
            this.getFAQs(value);
            this.isSuccess = false;
            this.isProductCodeReport = false;
        } else {
            this.faqs = {};
            this.formData.topic = null;
            this.isForm = false
        }
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getNewSupportTicketData();

        this.formData.vehicleType = this.defaultTopic ? 'Car' : null;
        this.formData.topic = this.defaultTopic ?? null;
    }

    public async getNewSupportTicketData() {
        const ticketData = (await Axios.post(this.routes.MyBremboPartsSupport_GetNewSupportTicketData, null)).data;
        this.isHoliday = ticketData.isHoliday;
        this.redirectUrl = ticketData.redirectUrl;
        this.topics = ticketData.topics;
    }

    public async getFAQs(topic) {
        this.isForm = false;
        this.isProductCodeReport = false;

        this.faqs = (await Axios.post(this.routes.FAQ_List, { topic: topic })).data;

        if (this.faqs.some((x) => x.faq.isInfoRequest)) {
            this.isForm = true;
            this.isProductCodeReport = topic === "Complaints";
        }
    }

    public setRegistrationFileName() {
        let registrationFile = (<any>this).$refs.registrationFile;
        this.registrationFileName = null;

        if (registrationFile.files.length !== 0 && registrationFile.files[0].name) {
            this.registrationFileName = registrationFile.files[0].name;
        }
    }

    public changeVehicleType() {
        if (this.formData.vehicleType !== 'Car') {
            this.faqs = {};
            this.formData.topic = null;
            this.isForm = false
        }
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        let multipartData = new FormData();

        if ((<any>this).$refs.registrationFile.files[0]) {
            multipartData.append("inputFile", (<any>this).$refs.registrationFile.files[0]);
        }

        this.formData.region = this.region;

        for (const key in this.formData) {
            if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
                multipartData.append(key, this.formData[key]);
            }
        }

        try {
            await Axios.post(this.routes.MyBremboPartsSupport_SaveSupportTicket, multipartData);

            this.isSuccess = true;
            this.isForm = false;

            GTagHelper.sendEvent("form_submit", "ticket", this.formData.topic);
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }

    public setSupportArticleEvent(articleTitle: string) {
        GTagHelper.sendEvent("click", "ticket", "read_article");
    }
};